import React from 'react'
import styled from 'styled-components'
import { darkTheme } from '../Themes'
import { NavLink } from 'react-router-dom'



const Logo =styled.h1`
    display: inline-block;
    color:${props=>props.color === 'dark' ? darkTheme.text : darkTheme.body};
    font-family:'Pacifico',cursive;
    position:fixed;
    // position:absolute;
    left:2rem;
    top:2rem;
    z-index: 3;
    @media (max-width: 720px) {
      position: absolute;
  }
` 

function LogoComponent(props) {
  return (
    <NavLink to="/">
    <Logo color={props.theme}>
       MG
    </Logo>
    </NavLink>
  )
}

export default LogoComponent